var trackingEvent = require('src/interlock/no-ui/tracking/event');
var commonMap = require('src/interlock/no-ui/tracking/maps/common');
var constant = require('src/interlock/no-ui/tracking/constant');

var map = {
    core_page_website_clickout: trackingEvent.actionCompleted(
        constant.ACTION_WEBSITE_CLICKOUT, 'oem_site_clickout'),

    core_page_view_consumer_review: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_REVIEW, 'view_consumer_review'),

    core_page_go_to_review_form: trackingEvent.actionCompleted(
        constant.ACTION_WRITE_REVIEW, 'go_to_review_form'),

    core_page_view_content_pricing_details: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_PRICING_DETAILS),

    core_page_view_content_edmunds_review: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_EDMUNDS_REVIEW),

    core_page_view_content_specs: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_specs'),

    core_page_view_content_incentives: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_incentives_deals'),

    core_page_view_content_features: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_features'),

    core_page_view_content_safety_features: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_safety_features'),

    sign_in: trackingEvent.actionCompleted(
        'sign_in', constant.VIEW_PRICING_DETAILS)
};

module.exports = $.extend({}, commonMap, map);



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/maps/core-page/index.js
// module id = 98
// module chunks = 0 1 3 6 8 11 12 14